<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Language from '@/dc-it/models/Language'

export default {
  name: 'LanguagesView',
  components: { TableComponent },
  data() {
    return {
      model: Language,
    }
  },
}
</script>

<style scoped>

</style>
